import React, { useState } from "react";
import {Box, Grid} from '@material-ui/core';
import {TextField} from '@mui/material';
import DialogStudyContent from '../DialogStudyContent';
import CircularProgress from '@mui/material/CircularProgress';
// Styles
import styles from "./BottomDrawerStdyMat.module.css";
import ValidityExpiredDialog from "../ValidityExpiredDialog";
import ContentLimitAlert from "../ContentLimitAlert";


const BottomDrawer = (props) => {
	var selectedCourse = localStorage.getItem('etlSelectCourse'); 	
	var mySelectedCourses = JSON.parse(localStorage.getItem('etlMyCourses'));

  // States
  const [isExpanded, setIsExpanded] = useState(false);

  const childRef = React.useRef();
	const childRefLimit = React.useRef();
	const childRefVED = React.useRef();

  const [organisationName, setOrganisationName] = React.useState("");
	const [validityExpired, setValidityExpired] = React.useState(false);

  const [contentObj, setContentObj] = React.useState({});
  const [material, setMaterial] = React.useState('');
  const [language, setLanguage] = React.useState('');


  // Utility Function
  // Function to toggle the bottom nav
  const setBottomNavStatus = () => {
    setIsExpanded(!isExpanded);
  };

	function exeContent(obj){ 
		if(validityExpired===true){
			childRefVED.current.handleClickOpen();

		}else{
			let openContentFlag = true;
			if(mySelectedCourses && selectedCourse>-1 && mySelectedCourses[selectedCourse].packTypeTitle && mySelectedCourses[selectedCourse].organisationName.indexOf("FOREVER")===-1 && mySelectedCourses[selectedCourse].packTypeTitle.indexOf("FREE")>-1){
				if(obj && (obj.contentType==='PDF' || obj.contentType==='PPT')){
					////alert(localStorage.getItem("contentPDFCounterJson"));
					if(localStorage.getItem("contentPDFCounterJson") && localStorage.getItem("contentPDFCounterJson").length>3){
						let pdfCountArr = JSON.parse(localStorage.getItem("contentPDFCounterJson"));
						let foundCourse = false;
						for(let i=0; i<pdfCountArr.length; i++){
							if(pdfCountArr[i].courseId===mySelectedCourses[selectedCourse].courseId){
								if(pdfCountArr[i].counter && pdfCountArr[i].counter>=2 && pdfCountArr[i].contentIds.indexOf(obj.id)===-1){
									openContentFlag = false;
									childRefLimit.current.handleClickOpen();
								}else if(pdfCountArr[i].contentIds && pdfCountArr[i].contentIds.indexOf(obj.id)===-1){
									pdfCountArr[i].counter = pdfCountArr[i].counter+1;
									pdfCountArr[i].contentIds = pdfCountArr[i].contentIds+','+obj.id;
									localStorage.setItem("contentPDFCounterJson",JSON.stringify(pdfCountArr));
								}
								foundCourse = true;
							}
						}
						if(foundCourse === false){
							pdfCountArr.push({counter:1,courseId:mySelectedCourses[selectedCourse].courseId,contentIds:'b'+obj.id});
							localStorage.setItem("contentPDFCounterJson",JSON.stringify(pdfCountArr));
						}
					}else{
						localStorage.setItem("contentPDFCounterJson",JSON.stringify([{counter:1,courseId:mySelectedCourses[selectedCourse].courseId,contentIds:'b'+obj.id}]));
					}

				}else if(obj && obj.contentType==='Text'){	
					////alert(localStorage.getItem("contentTextCounterJson"));		
					if(localStorage.getItem("contentTextCounterJson") && localStorage.getItem("contentTextCounterJson").length>3){
						let txtCountArr = JSON.parse(localStorage.getItem("contentTextCounterJson"));
						let foundCourse = false;
						for(let i=0; i<txtCountArr.length; i++){
							if(txtCountArr[i].courseId===mySelectedCourses[selectedCourse].courseId){
								if(txtCountArr[i].counter && txtCountArr[i].counter>=2 && txtCountArr[i].contentIds && txtCountArr[i].contentIds.indexOf(obj.id)===-1){
									openContentFlag = false;
									childRefLimit.current.handleClickOpen();
								}else if(txtCountArr[i].contentIds && txtCountArr[i].contentIds.indexOf(obj.id)===-1){
									txtCountArr[i].counter = txtCountArr[i].counter+1;
									txtCountArr[i].contentIds = txtCountArr[i].contentIds+','+obj.id;
									localStorage.setItem("contentTextCounterJson",JSON.stringify(txtCountArr));
								}
								foundCourse = true;
							}
						}
						if(foundCourse === false){
							txtCountArr.push({counter:1,courseId:mySelectedCourses[selectedCourse].courseId,contentIds:'a'+obj.id});
							localStorage.setItem("contentTextCounterJson",JSON.stringify(txtCountArr));
						}
					}else{
						localStorage.setItem("contentTextCounterJson",JSON.stringify([{counter:1,courseId:mySelectedCourses[selectedCourse].courseId,contentIds:'a'+obj.id}]));
					}

				}
			}

			if(openContentFlag === true){
				setContentObj(obj);
				childRef.current.handleClickOpen();	
			}
			
		}

	}

  function handleMaterial(typ){
    setMaterial(typ);
    props.handleMaterial(typ);
  }

  function handleLanguage(lang){
    setLanguage(lang);
    props.handleLanguage(lang);
  }

  React.useEffect(() => {		
		if(selectedCourse && selectedCourse>=0){
			// Check validity ************************************
			setOrganisationName(mySelectedCourses[selectedCourse].organisationName);
			var d1 = new Date();
			var d2 = new Date(mySelectedCourses[selectedCourse].validTillDate);
			d2.setDate(d2.getDate() + 1);
			if(d1>d2 && mySelectedCourses[selectedCourse].packTypeTitle.indexOf("FREE")===-1){
				setValidityExpired(true);      
			}else{
				setValidityExpired(false);
			}
		}
	}, [selectedCourse]); 

  return (
    <div className={styles.bottom_drawer}>
      {/* Condition to check if the bottom nav is expanded or not */}
      {!isExpanded ? ( // Minimized view
        <div onClick={setBottomNavStatus} className={styles.bottom_min_mode}>
          {/* Arrow Animation */}
          <div className={styles.bottom_arrow}>
            <img
              src={process.env.PUBLIC_URL+"/arrow-up.svg"}
              className={styles.bottom_arrow_svg}
              alt="ETL arrow"
            />
          </div>

          {/* Text Content */}
          <div className={styles.bottom_main_content}>
            <p>{props.searchQuery}</p>
              {(props.materialsList && props.materialsList.length>0)?
                <>Click to expand for study material</>
                :<div style={{color:'#FF0000',fontSize:14,fontWeight:'bold',textAlign:'center',width:'100%'}}>Study material not found</div>
              }
              
          </div>


        </div>
      ) : (
        // Expanded View
        <div className={styles.bottom_expanded}>
          {/* Down Arrow */}
          <div
            onClick={() => {
              setIsExpanded(false);
            }}
            className={styles.bottom_arrow_down}
          >
            <img
              src={process.env.PUBLIC_URL+"/arrow-up.svg"}
              className={styles.bottom_arrow_svg_down}
              alt="ETL arrow"
            />
          </div>
          {/* Main Text Content Start */}
          <div className={styles.bottom_main_content}>
            <p>{props.searchQuery}</p>

              <Box m={2}>
              {props.searchQuery?
									<Box mt={3} >
                    {(props.materialsList && props.materialsList.length>0 && ((props.languageList && props.languageList?.length>0) || (props.materials && props.materials?.length>0)) )?
                      <Grid container spacing={2} style={{width:'97vw'}} >
                        {(props.languageList && props.languageList?.length>0 )?
                        <Grid xs={6} >
                          <TextField
                            id="outlined-select-native"
                            select
                            label="Languages"
                            value={language}
                            onChange={(event)=>{handleLanguage(event.target.value)}}
                            SelectProps={{
                              native: true,
                            }}	
                            InputLabelProps={{shrink:true}}
                            size='small'	
                            ///classes={{ paper: classes.paper }}
                            sx={{width:'97%', backgroundColor:'#fff'}}					
                          >
                            <option value='' >All</option>
                            {props.languageList.map((row) => (
                              <option key={row} value={row}>
                              {row}
                              </option>
                            ))}
                          </TextField>
                        </Grid>
                        :null}
                        <Grid xs={(props.languageList && props.languageList.length>0)?6:12} >
                          <TextField
                            id="outlined-select-native"
                            select
                            label="Filter"
                            value={material}
                            onChange={(event)=>{handleMaterial(event.target.value)}}
                            SelectProps={{
                              native: true,
                            }}	
                            InputLabelProps={{shrink:true}}
                            size='small'	
                            fullWidth
                            sx={{backgroundColor:'#fff'}}
                          >
                            <option value='' >All</option>
                            {props.materials.map((row) => (
                              <option key={row} value={row}>{row}</option>
                            ))}
                          </TextField>
                        </Grid>
                      </Grid>
                    :null}
                    <Box component="form" noValidate mt={2} className="selfTestForm animate-zoom" >
                      <Grid container spacing={2} className="materialBoxx" >
                      {props.showProgress?<div style={{textAlign:'center',width:'100%'}}><CircularProgress style={{width:20,height:20}} /><br/>Loading...</div>:(props.materialsDisplayList && props.materialsDisplayList.length>0)?props.materialsDisplayList.map((myRow,index)=>(				
                        <Grid onClick={()=>{exeContent(myRow)}} key={'mtldd'+index} item className="smitem" >
                          <p style={{fontSize:'smaller',marginTop:-8,textAlign:'right'}}>&nbsp;{myRow.language}</p>
                          <p>
                            {myRow.contentType=='Video'?<i className="fa fa-play-circle"></i>:myRow.contentType=='PDF'?<i className="fa fa-file-pdf-o"></i>:myRow.contentType=='PPT'?<i className="fa fa-file-powerpoint-o"></i>:<i className="fa fa-globe"></i>}												
                          </p>
                          <p className="text-line-2">
                            {myRow.contentTitle}
                          </p>	
                        </Grid>
                      )):<div style={{color:'#FF0000',fontSize:14,fontWeight:'bold',textAlign:'center',width:'100%'}}>Study material not found</div>}	
                      </Grid>	
    								</Box>
									</Box>
                  :null}
							</Box>

          </div>
          {/* Main Text Content End */}

          <DialogStudyContent topic={props.searchQuery} contentObj={contentObj} ref={childRef} />
          <ContentLimitAlert ref={childRefLimit} />
				  <ValidityExpiredDialog organisationName={organisationName} ref={childRefVED}  />

        </div>
      )}
    </div>
  );
};

export default BottomDrawer;
